
import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  FaSignOutAlt,
  FaEye,
  FaEyeSlash,
  FaStore,
  FaPlus,
  FaEdit,
  FaSave,
  FaTimes,
  FaUserTie,
  FaClock,
  FaCoffee,
  FaWhatsapp,
  FaShieldAlt,
  FaSearch,
  FaSyncAlt,
  FaGlobe,
  FaEnvelope,
  FaCheckCircle,
  FaExclamationCircle,
  FaBuilding,
} from "react-icons/fa";
import PaymentSettingsSuperadmin from "../components/PaymentSettingsSuperadmin";

const API = "https://acesso.cronosagenda.com.br/api/systmanag";

const FORM_INICIAL = {
  nome: "",
  email: "",
  senha: "",
  subdominio: "",
  dias_fechamento: "",
  logo_url: "",
  envio_mensagens: false,
  numero_whatsapp: "",
  whatsapp_access_token: "",
  whatsapp_phone_number_id: "",
  whatsapp_business_account_id: "",
  mensagem_whatsapp: "",
  envio_confirmacao_profissional: false,
  jwt_superadmin: "",
};

const FUNCIONARIO_INICIAL = {
  nome: "",
  horario_inicio: "",
  horario_fim: "",
  barbearia_id: "",
};

const HORARIO_INICIAL = {
  funcionario_id: "",
  dia_da_semana: "",
  horario_inicio: "",
  horario_fim: "",
  barbearia_id: "",
};

const PAUSA_INICIAL = {
  funcionario_id: "",
  dia_da_semana: "",
  horario_inicio: "",
  horario_fim: "",
  barbearia_id: "",
};

const DIAS_SEMANA = [
  { value: "domingo", label: "Domingo" },
  { value: "segunda", label: "Segunda-feira" },
  { value: "terca", label: "Terça-feira" },
  { value: "quarta", label: "Quarta-feira" },
  { value: "quinta", label: "Quinta-feira" },
  { value: "sexta", label: "Sexta-feira" },
  { value: "sabado", label: "Sábado" },
];

const AdicionarBarbearia = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState(FORM_INICIAL);
  const [funcionarioData, setFuncionarioData] = useState(FUNCIONARIO_INICIAL);
  const [horarioData, setHorarioData] = useState(HORARIO_INICIAL);
  const [pausaData, setPausaData] = useState(PAUSA_INICIAL);

  const [barbearias, setBarbearias] = useState([]);
  const [funcionariosHorario, setFuncionariosHorario] = useState([]);
  const [funcionariosPausa, setFuncionariosPausa] = useState([]);

  const [selectedBarbeariaHorario, setSelectedBarbeariaHorario] = useState("");
  const [selectedBarbeariaPausa, setSelectedBarbeariaPausa] = useState("");
  const [selectedBarbeariaFuncionario, setSelectedBarbeariaFuncionario] =
    useState("");

  const [editando, setEditando] = useState(false);
  const [idEditando, setIdEditando] = useState(null);
  const [showSenha, setShowSenha] = useState(false);
  const [showWhatsappToken, setShowWhatsappToken] = useState(false);
  const [buscaBarbearia, setBuscaBarbearia] = useState("");

  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [carregandoBarbearias, setCarregandoBarbearias] = useState(false);
  const [salvandoBarbearia, setSalvandoBarbearia] = useState(false);
  const [salvandoFuncionario, setSalvandoFuncionario] = useState(false);
  const [salvandoHorario, setSalvandoHorario] = useState(false);
  const [salvandoPausa, setSalvandoPausa] = useState(false);

  const mostrarErro = (mensagem) => {
    setSuccessMessage("");
    setErrorMessage(mensagem);
  };

  const mostrarSucesso = (mensagem) => {
    setErrorMessage("");
    setSuccessMessage(mensagem);
  };

  const limparMensagens = () => {
    setErrorMessage("");
    setSuccessMessage("");
  };

  const fetchBarbearias = useCallback(async () => {
    setCarregandoBarbearias(true);

    try {
      const response = await axios.get(`${API}/barbearias`, {
        withCredentials: true,
      });

      setBarbearias(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      mostrarErro(
        `Erro ao carregar barbearias: ${
          error.response?.data?.message || error.message
        }`
      );
    } finally {
      setCarregandoBarbearias(false);
    }
  }, []);

  const fetchFuncionariosPorBarbearia = async (barbeariaId, destino) => {
    if (!barbeariaId) {
      destino([]);
      return;
    }

    try {
      const response = await axios.get(
        `${API}/funcionarios/${barbeariaId}`,
        { withCredentials: true }
      );

      destino(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Erro ao carregar funcionários:", error);

      destino([]);

      mostrarErro(
        `Erro ao carregar funcionários: ${
          error.response?.data?.error || error.message
        }`
      );
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("superadmin_token");

    if (token) {
      setFormData((prev) => ({
        ...prev,
        jwt_superadmin: token,
      }));
    }

    fetchBarbearias();
  }, [fetchBarbearias]);

  const handleConfigurar2FA = () => {
    navigate("/sistema/configuracoes-2fa");
  };

  const handleLogout = async () => {
    try {
      await axios.post(
        "/api/superadmin/logout",
        {},
        { withCredentials: true }
      );

      sessionStorage.clear();
      navigate("/acesso-superadmin");
    } catch (error) {
      mostrarErro(
        `Não foi possível sair: ${
          error.response?.data?.message || error.message
        }`
      );
    }
  };

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleEdit = (barbearia) => {
    limparMensagens();

    setFormData({
      nome: barbearia.nome || "",
      email: barbearia.email || "",
      senha: "",
      subdominio: barbearia.subdominio || "",
      dias_fechamento: barbearia.dias_fechamento || "",
      logo_url: barbearia.logo_url || "",
      envio_mensagens: Boolean(barbearia.envio_mensagens),
      numero_whatsapp: barbearia.numero_whatsapp || "",
      whatsapp_access_token: barbearia.whatsapp_access_token || "",
      whatsapp_phone_number_id: barbearia.whatsapp_phone_number_id || "",
      whatsapp_business_account_id:
        barbearia.whatsapp_business_account_id || "",
      mensagem_whatsapp: barbearia.mensagem_whatsapp || "",
      envio_confirmacao_profissional: Boolean(
        barbearia.envio_confirmacao_profissional
      ),
      jwt_superadmin: sessionStorage.getItem("superadmin_token") || "",
    });

    setEditando(true);
    setIdEditando(barbearia.id);

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const cancelarEdicao = () => {
    setFormData({
      ...FORM_INICIAL,
      jwt_superadmin: sessionStorage.getItem("superadmin_token") || "",
    });

    setEditando(false);
    setIdEditando(null);
    setShowSenha(false);
    setShowWhatsappToken(false);
    limparMensagens();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    limparMensagens();
    setSalvandoBarbearia(true);

    try {
      const dadosParaEnviar = { ...formData };

      if (!dadosParaEnviar.senha?.trim()) {
        delete dadosParaEnviar.senha;
      }

      let response;

      if (editando) {
        response = await axios.put(
          `${API}/editar_barbearia/${idEditando}`,
          dadosParaEnviar,
          { withCredentials: true }
        );
      } else {
        response = await axios.post(
          `${API}/adicionar_barbearia`,
          dadosParaEnviar,
          { withCredentials: true }
        );
      }

      const mensagemSucesso =
        response.data?.message ||
        (editando
          ? "Barbearia atualizada com sucesso."
          : "Barbearia cadastrada com sucesso.");

      cancelarEdicao();
      mostrarSucesso(mensagemSucesso);
      await fetchBarbearias();
    } catch (error) {
      mostrarErro(
        `Erro ao ${editando ? "editar" : "adicionar"} barbearia: ${
          error.response?.data?.message ||
          error.response?.data?.error ||
          error.message
        }`
      );
    } finally {
      setSalvandoBarbearia(false);
    }
  };

  const handleBarbeariaFuncionarioChange = (event) => {
    const barbeariaId = event.target.value;

    setSelectedBarbeariaFuncionario(barbeariaId);
    setFuncionarioData((prev) => ({
      ...prev,
      barbearia_id: barbeariaId,
    }));
  };

  const handleFuncionarioChange = (event) => {
    const { name, value } = event.target;

    setFuncionarioData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFuncionarioSubmit = async (event) => {
    event.preventDefault();
    limparMensagens();
    setSalvandoFuncionario(true);

    try {
      const response = await axios.post(
        `${API}/adicionar_funcionario`,
        funcionarioData,
        { withCredentials: true }
      );

      mostrarSucesso(
        response.data?.message || "Funcionário cadastrado com sucesso."
      );

      setFuncionarioData(FUNCIONARIO_INICIAL);
      setSelectedBarbeariaFuncionario("");
    } catch (error) {
      mostrarErro(
        `Erro ao adicionar funcionário: ${
          error.response?.data?.error ||
          error.response?.data?.message ||
          error.message
        }`
      );
    } finally {
      setSalvandoFuncionario(false);
    }
  };

  const handleBarbeariaHorarioChange = (event) => {
    const barbeariaId = event.target.value;

    setSelectedBarbeariaHorario(barbeariaId);
    setHorarioData((prev) => ({
      ...prev,
      barbearia_id: barbeariaId,
      funcionario_id: "",
    }));

    setFuncionariosHorario([]);
    fetchFuncionariosPorBarbearia(barbeariaId, setFuncionariosHorario);
  };

  const handleHorarioChange = (event) => {
    const { name, value } = event.target;

    setHorarioData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleHorarioSubmit = async (event) => {
    event.preventDefault();
    limparMensagens();
    setSalvandoHorario(true);

    try {
      const response = await axios.post(
        `${API}/adicionar_horarios`,
        horarioData,
        { withCredentials: true }
      );

      mostrarSucesso(
        response.data?.message || "Horário cadastrado com sucesso."
      );

      setHorarioData({
        ...HORARIO_INICIAL,
        barbearia_id: "",
      });
      setSelectedBarbeariaHorario("");
      setFuncionariosHorario([]);
    } catch (error) {
      mostrarErro(
        `Erro ao adicionar horário: ${
          error.response?.data?.error ||
          error.response?.data?.message ||
          error.message
        }`
      );
    } finally {
      setSalvandoHorario(false);
    }
  };

  const handleBarbeariaPausaChange = (event) => {
    const barbeariaId = event.target.value;

    setSelectedBarbeariaPausa(barbeariaId);
    setPausaData((prev) => ({
      ...prev,
      barbearia_id: barbeariaId,
      funcionario_id: "",
    }));

    setFuncionariosPausa([]);
    fetchFuncionariosPorBarbearia(barbeariaId, setFuncionariosPausa);
  };

  const handlePausaChange = (event) => {
    const { name, value } = event.target;

    setPausaData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePausaSubmit = async (event) => {
    event.preventDefault();
    limparMensagens();
    setSalvandoPausa(true);

    try {
      const response = await axios.post(
        `${API}/adicionar_pausa`,
        pausaData,
        { withCredentials: true }
      );

      mostrarSucesso(
        response.data?.message || "Pausa cadastrada com sucesso."
      );

      setPausaData(PAUSA_INICIAL);
      setSelectedBarbeariaPausa("");
      setFuncionariosPausa([]);
    } catch (error) {
      mostrarErro(
        `Erro ao adicionar pausa: ${
          error.response?.data?.error ||
          error.response?.data?.message ||
          error.message
        }`
      );
    } finally {
      setSalvandoPausa(false);
    }
  };

  const barbeariasFiltradas = barbearias.filter((barbearia) => {
    const termo = buscaBarbearia.trim().toLowerCase();

    if (!termo) return true;

    return [
      barbearia.nome,
      barbearia.email,
      barbearia.subdominio,
      barbearia.numero_whatsapp,
    ].some((valor) => String(valor || "").toLowerCase().includes(termo));
  });

  const renderSelectBarbearia = (value, onChange, required = true) => (
    <select
      value={value}
      onChange={onChange}
      required={required}
      className="cronos-input"
    >
      <option value="">Selecione uma barbearia</option>
      {barbearias.map((barbearia) => (
        <option key={barbearia.id} value={barbearia.id}>
          {barbearia.nome} ({barbearia.subdominio})
        </option>
      ))}
    </select>
  );

  const renderSelectFuncionario = (value, onChange, funcionarios, disabled) => (
    <select
      name="funcionario_id"
      value={value}
      onChange={onChange}
      required
      disabled={disabled}
      className="cronos-input"
    >
      <option value="">
        {disabled
          ? "Selecione uma barbearia primeiro"
          : funcionarios.length
            ? "Selecione um funcionário"
            : "Nenhum funcionário encontrado"}
      </option>
      {funcionarios.map((funcionario) => (
        <option key={funcionario.id} value={funcionario.id}>
          {funcionario.nome}
        </option>
      ))}
    </select>
  );

  return (
    <div className="cronos-admin">
      <style>{`
        .cronos-admin {
          --ca-bg: #090a0c;
          --ca-card: #111214;
          --ca-card-hover: #151619;
          --ca-text: #f2f0eb;
          --ca-muted: #96969b;
          --ca-border: #292a2e;
          --ca-primary: #c7a45b;
          --ca-primary-hover: #dfbd76;
          --ca-radius: 16px;
          min-height: 100vh;
                    padding: clamp(14px, 2.5vw, 32px);
                    color: var(--ca-text);
                    background:
                      radial-gradient(ellipse at 50% -15%, rgba(174, 133, 54, .09), transparent 45%),
                      #090a0c;
                    font-family: Inter, ui-sans-serif, system-ui, -apple-system,
                      BlinkMacSystemFont, "Segoe UI", sans-serif;
                    box-sizing: border-box;
                  }
          .cronos-admin *,
                  .cronos-admin *::before,
                  .cronos-admin *::after {
                    box-sizing: border-box;
                  }
          .ca-shell {
                    width: 100%;
                    max-width: 1500px;
                    margin: 0 auto;
                  }
                  /* CABEÇALHO */
          .ca-topbar {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 18px;
                    flex-wrap: wrap;
                    margin-bottom: 28px;
                    padding-bottom: 22px;
                    border-bottom: 1px solid #262629;
                  }
          .ca-brand {
                    display: flex;
                    align-items: center;
                    gap: 15px;
                    min-width: 0;
                  }
          .ca-brand-icon {
                    display: grid;
                    place-items: center;
                    width: 50px;
                    height: 50px;
                    flex: 0 0 50px;
                    border: 1px solid rgba(199, 164, 91, .3);
                    border-radius: 15px;
                    color: #d6b66f;
                    background: linear-gradient(145deg, #211d14, #15130f);
                    box-shadow: 0 8px 28px rgba(0, 0, 0, .25);
                    font-size: 20px;
                  }
          .ca-brand h1 {
                    margin: 0;
                    color: #f4f1e9;
                    font-size: clamp(21px, 2.5vw, 29px);
                    font-weight: 800;
                    letter-spacing: -.8px;
                  }
          .ca-brand p {
                    margin: 6px 0 0;
                    color: #929197;
                    font-size: 13px;
                  }
          .ca-actions {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 10px;
                  }
                  /* BOTÕES */
          .ca-button {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    min-height: 42px;
                    padding: 10px 15px;
                    border: 1px solid transparent;
                    border-radius: 10px;
                    font: inherit;
                    font-size: 12px;
                    font-weight: 750;
                    cursor: pointer;
                    transition: background .2s ease, border-color .2s ease,
                      color .2s ease, transform .2s ease, box-shadow .2s ease;
                  }
          .ca-button:hover:not(:disabled) {
                    transform: translateY(-1px);
                  }
          .ca-button:focus-visible {
                    outline: 2px solid #d7b66d;
                    outline-offset: 3px;
                  }
          .ca-button:disabled {
                    opacity: .55;
                    cursor: not-allowed;
                  }
          .ca-button-primary {
                    color: #17130a;
                    background: linear-gradient(135deg, #d9ba78, #b99349);
                    border-color: #d0ae69;
                    box-shadow: 0 4px 14px rgba(190, 151, 76, .1);
                  }
          .ca-button-primary:hover:not(:disabled) {
                    background: linear-gradient(135deg, #ebce8c, #c8a35b);
                    box-shadow: 0 5px 18px rgba(190, 151, 76, .16);
                  }
          .ca-button-secondary {
                    color: #dedde0;
                    background: #17181b;
                    border-color: #35363b;
                  }
          .ca-button-secondary:hover:not(:disabled) {
                    color: #e2c27e;
                    background: #202024;
                    border-color: #6c5935;
                  }
          .ca-button-danger {
                    color: #f0a6a6;
                    background: #211415;
                    border-color: #512729;
                  }
          .ca-button-danger:hover:not(:disabled) {
                    background: #30191b;
                    border-color: #78383b;
                  }
          .ca-button-success {
                    color: #111;
                    background: #c7a45b;
                  }
                  /* AVISOS */
          .ca-alert {
                    display: flex;
                    align-items: flex-start;
                    gap: 10px;
                    padding: 14px 16px;
                    border-radius: 11px;
                    margin-bottom: 17px;
                    font-size: 13px;
                    line-height: 1.55;
                    overflow-wrap: anywhere;
                  }
          .ca-alert-error {
                    color: #ffb5b5;
                    background: #211315;
                    border: 1px solid #592b30;
                  }
          .ca-alert-success {
                    color: #a8e7bd;
                    background: #111f18;
                    border: 1px solid #294d38;
                  }
                  /* CARDS */
          .ca-card {
                    min-width: 0;
                    padding: clamp(18px, 2vw, 27px);
                    margin-bottom: 22px;
                    background: linear-gradient(145deg, #131416, #101113);
                    border: 1px solid #292a2e;
                    border-radius: var(--ca-radius);
                    box-shadow: 0 12px 35px rgba(0, 0, 0, .12);
                  }
          .ca-card-heading {
                    display: flex;
                    align-items: flex-start;
                    gap: 13px;
                    margin-bottom: 22px;
                  }
          .ca-heading-icon {
                    display: grid;
                    place-items: center;
                    flex: 0 0 43px;
                    width: 43px;
                    height: 43px;
                    border-radius: 12px;
                    color: #d4b36c;
                    background: #211d14;
                    border: 1px solid #3c3220;
                    font-size: 16px;
                  }
          .ca-card-heading h2 {
                    margin: 1px 0 0;
                    color: #f0eee9;
                    font-size: 17px;
                    font-weight: 800;
                    letter-spacing: -.35px;
                  }
          .ca-card-heading p {
                    margin: 6px 0 0;
                    color: #93939a;
                    font-size: 12px;
                    line-height: 1.6;
                  }
          .ca-section-label {
                    margin: 25px 0 15px;
                    padding-bottom: 11px;
                    border-bottom: 1px solid #292a2d;
                    color: #c5a96b;
                    font-size: 10px;
                    font-weight: 800;
                    letter-spacing: .12em;
                    text-transform: uppercase;
                  }
                  /* GRIDS E CAMPOS */
          .ca-grid {
                    display: grid;
                    grid-template-columns: repeat(2, minmax(0, 1fr));
                    gap: 17px;
                  }
          .ca-grid-3 {
                    display: grid;
                    grid-template-columns: repeat(3, minmax(0, 1fr));
                    gap: 17px;
                  }
          .ca-field {
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                    min-width: 0;
                  }
          .ca-field label {
                    color: #d5d3d0;
                    font-size: 12px;
                    font-weight: 700;
                  }
          .ca-field small {
                    color: #85858c;
                    font-size: 11px;
                    line-height: 1.5;
                  }
                  /* INPUTS, SELECTS E TEXTAREAS */
          .cronos-input {
                    display: block;
                    width: 100%;
                    min-width: 0;
                    min-height: 44px;
                    padding: 11px 13px;
                    color: #eeeef0;
                    background: #0c0d0f;
                    border: 1px solid #333439;
                    border-radius: 10px;
                    outline: none;
                    font: inherit;
                    font-size: 13px;
                    transition: border-color .18s ease, box-shadow .18s ease,
                      background .18s ease;
                    color-scheme: dark;
                  }
          .cronos-input::placeholder {
                    color: #65656c;
                    opacity: 1;
                  }
          .cronos-input:focus {
                    border-color: #b99a58;
                    background: #101113;
                    box-shadow: 0 0 0 3px rgba(199, 164, 91, .11);
                  }
          .cronos-input:disabled {
                    color: #74747a;
                    background: #18191b;
                    border-color: #292a2d;
                    cursor: not-allowed;
                  }
          textarea.cronos-input {
                    min-height: 105px;
                    resize: vertical;
                  }
          .cronos-input option {
                    color: #eeeef0;
                    background: #151619;
                  }
          .ca-password {
                    position: relative;
                  }
          .ca-password .cronos-input {
                    padding-right: 45px;
                  }
          .ca-eye {
                    position: absolute;
                    right: 5px;
                    top: 50%;
                    transform: translateY(-50%);
                    display: grid;
                    place-items: center;
                    width: 34px;
                    height: 34px;
                    border: 0;
                    border-radius: 8px;
                    color: #9999a0;
                    background: transparent;
                    cursor: pointer;
                  }
          .ca-eye:hover {
                    color: #d8b970;
                    background: #24211a;
                  }
          .ca-sensitive {
                    background: #11100d;
                  }
                  /* OPÇÕES */
          .ca-checks {
                    display: grid;
                    grid-template-columns: repeat(2, minmax(0, 1fr));
                    gap: 12px;
                    margin-top: 17px;
                  }
          .ca-check {
                    display: flex;
                    align-items: flex-start;
                    gap: 11px;
                    min-width: 0;
                    padding: 14px;
                    background: #151619;
                    border: 1px solid #303136;
                    border-radius: 11px;
                    cursor: pointer;
                    transition: border-color .18s, background .18s;
                  }
          .ca-check:hover {
                    background: #1b1b1e;
                    border-color: #655332;
                  }
          .ca-check input {
                    width: 16px;
                    height: 16px;
                    margin-top: 2px;
                    accent-color: #c7a45b;
                    flex: 0 0 auto;
                  }
          .ca-check span {
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                  }
          .ca-check strong {
                    color: #dedde0;
                    font-size: 12px;
                  }
          .ca-check small {
                    color: #929198;
                    font-size: 11px;
                    line-height: 1.5;
                  }
          .ca-form-footer {
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    justify-content: flex-end;
                    gap: 10px;
                    margin-top: 23px;
                    padding-top: 19px;
                    border-top: 1px solid #292a2d;
                  }
                  /* PESQUISA E TABELA */
          .ca-table-tools {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    gap: 13px;
                    flex-wrap: wrap;
                    margin-bottom: 17px;
                  }
          .ca-search {
                    position: relative;
                    width: min(100%, 400px);
                  }
          .ca-search svg {
                    position: absolute;
                    left: 13px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #a9956b;
                    pointer-events: none;
                  }
          .ca-search input {
                    padding-left: 39px;
                  }
          .ca-count {
                    color: #a3a1a5;
                    font-size: 11px;
                    white-space: nowrap;
                  }
          .ca-table-wrap {
                    width: 100%;
                    overflow-x: auto;
                    border: 1px solid #2c2d31;
                    border-radius: 12px;
                    background: #101113;
                  }
          .ca-table {
                    width: 100%;
                    min-width: 760px;
                    border-collapse: collapse;
                    text-align: left;
                  }
          .ca-table th {
                    padding: 14px 15px;
                    color: #b9a474;
                    background: #191a1d;
                    border-bottom: 1px solid #333033;
                    font-size: 10px;
                    font-weight: 800;
                    text-transform: uppercase;
                    letter-spacing: .08em;
                    white-space: nowrap;
                  }
          .ca-table td {
                    padding: 15px;
                    border-top: 1px solid #252629;
                    color: #c8c7cb;
                    font-size: 12px;
                    vertical-align: middle;
                  }
          .ca-table tbody tr {
                    transition: background .15s ease;
                  }
          .ca-table tbody tr:hover {
                    background: #19191b;
                  }
          .ca-table tbody tr:first-child td {
                    border-top: 0;
                  }
          .ca-name {
                    color: #f0eee9;
                    font-weight: 750;
                  }
          .ca-subtext {
                    display: block;
                    margin-top: 5px;
                    color: #77777e;
                    font-size: 10px;
                  }
          .ca-domain {
                    display: inline-flex;
                    align-items: center;
                    gap: 7px;
                    color: #d1b16a;
                    overflow-wrap: anywhere;
                  }
          .ca-status {
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    padding: 6px 9px;
                    border-radius: 20px;
                    font-size: 10px;
                    font-weight: 750;
                    white-space: nowrap;
                  }
          .ca-status-on {
                    color: #9fe0b5;
                    background: #14251b;
                    border: 1px solid #294c36;
                  }
          .ca-status-off {
                    color: #aaa9af;
                    background: #202125;
                    border: 1px solid #37383d;
                  }
          .ca-empty {
                    padding: 38px 16px;
                    text-align: center;
                    color: #96959b;
                    font-size: 13px;
                  }
          .ca-empty svg {
                    display: block;
                    margin: 0 auto 13px;
                    font-size: 25px;
                    color: #b69a5e;
                  }
          .ca-form-grid {
                    display: grid;
                    grid-template-columns: repeat(2, minmax(0, 1fr));
                    gap: 13px;
                  }
          .ca-form-actions {
                    margin-top: 18px;
                  }
          .ca-note {
                    color: #828188;
                    font-size: 11px;
                    line-height: 1.6;
                    margin-top: 13px;
                  }
                  /* RODAPÉ */
          .cronos-admin footer {
                    color: #77767c !important;
                  }
                  /* RESPONSIVIDADE */
          @media (max-width: 760px) {
                    .cronos-admin {
                      padding: 13px;
                    }
          .ca-topbar {
                      align-items: stretch;
                      margin-bottom: 20px;
                    }
          .ca-brand {
                      gap: 12px;
                    }
          .ca-brand-icon {
                      width: 44px;
                      height: 44px;
                      flex-basis: 44px;
                    }
          .ca-actions {
                      width: 100%;
                    }
          .ca-actions .ca-button {
                      flex: 1;
                    }
          .ca-grid,
                    .ca-grid-3,
                    .ca-checks,
                    .ca-form-grid {
                      grid-template-columns: minmax(0, 1fr);
                    }
          .ca-card {
                      padding: 17px;
                      border-radius: 13px;
                    }
          .ca-form-footer {
                      justify-content: stretch;
                    }
          .ca-form-footer .ca-button {
                      flex: 1 1 100%;
                    }
          .ca-table-tools {
                      align-items: stretch;
                    }
          .ca-search {
                      width: 100%;
                    }
          .ca-table-tools > div:last-child {
                      flex-wrap: wrap;
                    }
                  }
          @media (max-width: 420px) {
                    .ca-actions {
                      flex-direction: column;
                    }
          .ca-actions .ca-button {
                      width: 100%;
                    }
          .ca-brand h1 {
                      font-size: 20px;
                    }
          .ca-card-heading h2 {
                      font-size: 15px;
                    }
                  }
          @media (prefers-reduced-motion: reduce) {
                    .cronos-admin *,
                    .cronos-admin *::before,
                    .cronos-admin *::after {
                      transition: none !important;
                      scroll-behavior: auto !important;
                    }
                  }
      `}</style>

      <div className="ca-shell">
        <header className="ca-topbar">
          <div className="ca-brand">
            <div className="ca-brand-icon">
              <FaStore />
            </div>
            <div>
              <h1>Painel Superadmin</h1>
              <p>Gestão centralizada do Cronos Agenda</p>
            </div>
          </div>

          <div className="ca-actions">
            <button
              type="button"
              className="ca-button ca-button-secondary"
              onClick={handleConfigurar2FA}
            >
              <FaShieldAlt /> Configurar 2FA
            </button>
            <button
              type="button"
              className="ca-button ca-button-danger"
              onClick={handleLogout}
            >
              <FaSignOutAlt /> Sair da conta
            </button>
          </div>
        </header>

        {errorMessage && (
          <div className="ca-alert ca-alert-error" role="alert">
            <FaExclamationCircle />
            <span>{errorMessage}</span>
          </div>
        )}

        {successMessage && (
          <div className="ca-alert ca-alert-success" role="status">
            <FaCheckCircle />
            <span>{successMessage}</span>
          </div>
        )}

        <PaymentSettingsSuperadmin />

        <section className="ca-card" id="formulario-barbearia">
          <div className="ca-card-heading">
            <div className="ca-heading-icon">
              {editando ? <FaEdit /> : <FaPlus />}
            </div>
            <div>
              <h2>{editando ? "Editar barbearia" : "Cadastrar barbearia"}</h2>
              <p>
                {editando
                  ? "Atualize os dados da unidade selecionada."
                  : "Cadastre uma nova unidade e configure os dados de acesso."}
              </p>
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="ca-section-label">Informações da unidade</div>

            <div className="ca-grid">
              <div className="ca-field">
                <label htmlFor="ca-nome">Nome da barbearia *</label>
                <input
                  id="ca-nome"
                  className="cronos-input"
                  type="text"
                  name="nome"
                  placeholder="Ex.: Barbearia Central"
                  value={formData.nome}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="ca-field">
                <label htmlFor="ca-email">E-mail de acesso *</label>
                <input
                  id="ca-email"
                  className="cronos-input"
                  type="email"
                  name="email"
                  placeholder="contato@barbearia.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="ca-field">
                <label htmlFor="ca-senha">
                  {editando ? "Nova senha" : "Senha de acesso *"}
                </label>
                <div className="ca-password">
                  <input
                    id="ca-senha"
                    className="cronos-input"
                    type={showSenha ? "text" : "password"}
                    name="senha"
                    placeholder={
                      editando
                        ? "Deixe em branco para manter a atual"
                        : "Defina uma senha"
                    }
                    value={formData.senha}
                    onChange={handleChange}
                    required={!editando}
                    autoComplete="new-password"
                  />
                  <button
                    type="button"
                    className="ca-eye"
                    aria-label={showSenha ? "Ocultar senha" : "Mostrar senha"}
                    onClick={() => setShowSenha((prev) => !prev)}
                  >
                    {showSenha ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
                {editando && (
                  <small>Por segurança, a senha atual não é exibida.</small>
                )}
              </div>

              <div className="ca-field">
                <label htmlFor="ca-subdominio">Subdomínio *</label>
                <input
                  id="ca-subdominio"
                  className="cronos-input"
                  type="text"
                  name="subdominio"
                  placeholder="minhabarbearia"
                  value={formData.subdominio}
                  onChange={handleChange}
                  required
                />
                <small>
                  Endereço público: subdominio.cronosagenda.com.br
                </small>
              </div>

              <div className="ca-field">
                <label htmlFor="ca-fechamento">Dias de fechamento</label>
                <input
                  id="ca-fechamento"
                  className="cronos-input"
                  type="text"
                  name="dias_fechamento"
                  placeholder="Ex.: 0,6"
                  value={formData.dias_fechamento}
                  onChange={handleChange}
                />
                <small>Informe os dias no formato já utilizado pelo sistema.</small>
              </div>

              <div className="ca-field">
                <label htmlFor="ca-logo">URL do logotipo</label>
                <input
                  id="ca-logo"
                  className="cronos-input"
                  type="text"
                  name="logo_url"
                  placeholder="/logos/logo_barbearia.png"
                  value={formData.logo_url}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="ca-section-label">Integração WhatsApp Business</div>

            <div className="ca-grid">
              <div className="ca-field">
                <label htmlFor="ca-token">Access Token</label>
                <div className="ca-password">
                  <input
                    id="ca-token"
                    className="cronos-input ca-sensitive"
                    type={showWhatsappToken ? "text" : "password"}
                    name="whatsapp_access_token"
                    placeholder="Token de acesso da Meta"
                    value={formData.whatsapp_access_token}
                    onChange={handleChange}
                    autoComplete="new-password"
                  />
                  <button
                    type="button"
                    className="ca-eye"
                    aria-label={
                      showWhatsappToken ? "Ocultar token" : "Mostrar token"
                    }
                    onClick={() => setShowWhatsappToken((prev) => !prev)}
                  >
                    {showWhatsappToken ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
                <small>Campo sensível: evite compartilhar capturas de tela.</small>
              </div>

              <div className="ca-field">
                <label htmlFor="ca-phone-id">Phone Number ID</label>
                <input
                  id="ca-phone-id"
                  className="cronos-input ca-sensitive"
                  type="text"
                  name="whatsapp_phone_number_id"
                  placeholder="ID do número no WhatsApp Business"
                  value={formData.whatsapp_phone_number_id}
                  onChange={handleChange}
                />
              </div>

              <div className="ca-field">
                <label htmlFor="ca-business-id">WhatsApp Business Account ID</label>
                <input
                  id="ca-business-id"
                  className="cronos-input ca-sensitive"
                  type="text"
                  name="whatsapp_business_account_id"
                  placeholder="ID da conta empresarial"
                  value={formData.whatsapp_business_account_id}
                  onChange={handleChange}
                />
              </div>

              <div className="ca-field">
                <label htmlFor="ca-whatsapp">Número de WhatsApp</label>
                <input
                  id="ca-whatsapp"
                  className="cronos-input"
                  type="tel"
                  name="numero_whatsapp"
                  placeholder="Ex.: 5511999999999"
                  value={formData.numero_whatsapp}
                  onChange={handleChange}
                />
              </div>

              <div className="ca-field" style={{ gridColumn: "1 / -1" }}>
                <label htmlFor="ca-mensagem">Mensagem padrão</label>
                <textarea
                  id="ca-mensagem"
                  className="cronos-input"
                  name="mensagem_whatsapp"
                  placeholder="Mensagem padrão utilizada pelo sistema..."
                  value={formData.mensagem_whatsapp}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="ca-checks">
              <label className="ca-check">
                <input
                  type="checkbox"
                  name="envio_mensagens"
                  checked={Boolean(formData.envio_mensagens)}
                  onChange={handleChange}
                />
                <span>
                  <strong>Envio automático de mensagens</strong>
                  <small>Permite o envio automático pelo WhatsApp.</small>
                </span>
              </label>

              <label className="ca-check">
                <input
                  type="checkbox"
                  name="envio_confirmacao_profissional"
                  checked={Boolean(formData.envio_confirmacao_profissional)}
                  onChange={handleChange}
                />
                <span>
                  <strong>Confirmação ao profissional</strong>
                  <small>Habilita a notificação de confirmação ao profissional.</small>
                </span>
              </label>
            </div>

            <div className="ca-section-label">Autorização administrativa</div>

            <div className="ca-field">
              <label htmlFor="ca-jwt">Token JWT do superadmin *</label>
              <input
                id="ca-jwt"
                className="cronos-input"
                type="password"
                name="jwt_superadmin"
                placeholder="Token administrativo"
                value={formData.jwt_superadmin || ""}
                onChange={handleChange}
                required
                autoComplete="off"
              />
              <small>
                O token é obtido da sessão atual do superadmin, quando disponível.
              </small>
            </div>

            <div className="ca-form-footer">
              {editando && (
                <button
                  type="button"
                  className="ca-button ca-button-secondary"
                  onClick={cancelarEdicao}
                  disabled={salvandoBarbearia}
                >
                  <FaTimes /> Cancelar edição
                </button>
              )}

              <button
                type="submit"
                className="ca-button ca-button-primary"
                disabled={salvandoBarbearia}
              >
                {salvandoBarbearia ? (
                  <>
                    <FaSyncAlt /> Salvando...
                  </>
                ) : editando ? (
                  <>
                    <FaSave /> Salvar alterações
                  </>
                ) : (
                  <>
                    <FaPlus /> Cadastrar barbearia
                  </>
                )}
              </button>
            </div>
          </form>
        </section>

        <section className="ca-card">
          <div className="ca-card-heading">
            <div className="ca-heading-icon">
              <FaBuilding />
            </div>
            <div>
              <h2>Barbearias cadastradas</h2>
              <p>Consulte as unidades e edite seus dados quando necessário.</p>
            </div>
          </div>

          <div className="ca-table-tools">
            <div className="ca-search">
              <FaSearch />
              <input
                className="cronos-input"
                type="search"
                placeholder="Buscar por nome, e-mail, subdomínio..."
                value={buscaBarbearia}
                onChange={(event) => setBuscaBarbearia(event.target.value)}
                aria-label="Buscar barbearias"
              />
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <span className="ca-count">
                {barbeariasFiltradas.length} de {barbearias.length} unidade(s)
              </span>
              <button
                type="button"
                className="ca-button ca-button-secondary"
                onClick={fetchBarbearias}
                disabled={carregandoBarbearias}
              >
                <FaSyncAlt /> Atualizar
              </button>
            </div>
          </div>

          {carregandoBarbearias ? (
            <div className="ca-empty">
              <FaSyncAlt />
              Carregando barbearias...
            </div>
          ) : barbeariasFiltradas.length === 0 ? (
            <div className="ca-empty">
              <FaStore />
              {barbearias.length === 0
                ? "Nenhuma barbearia cadastrada."
                : "Nenhuma unidade corresponde à sua busca."}
            </div>
          ) : (
            <div className="ca-table-wrap">
              <table className="ca-table">
                <thead>
                  <tr>
                    <th>Barbearia</th>
                    <th>E-mail</th>
                    <th>Subdomínio</th>
                    <th>WhatsApp</th>
                    <th>Mensagens</th>
                    <th>Ação</th>
                  </tr>
                </thead>
                <tbody>
                  {barbeariasFiltradas.map((barbearia) => (
                    <tr key={barbearia.id}>
                      <td>
                        <span className="ca-name">{barbearia.nome}</span>
                        <span className="ca-subtext">ID #{barbearia.id}</span>
                      </td>
                      <td>
                        <span style={{ display: "inline-flex", alignItems: "center", gap: 7 }}>
                          <FaEnvelope style={{ color: "#98a2b3" }} />
                          {barbearia.email || "Não informado"}
                        </span>
                      </td>
                      <td>
                        <span className="ca-domain">
                          <FaGlobe />
                          {barbearia.subdominio || "Não configurado"}
                        </span>
                      </td>
                      <td>{barbearia.numero_whatsapp || "Não configurado"}</td>
                      <td>
                        <span
                          className={`ca-status ${
                            barbearia.envio_mensagens
                              ? "ca-status-on"
                              : "ca-status-off"
                          }`}
                        >
                          {barbearia.envio_mensagens ? (
                            <FaCheckCircle />
                          ) : (
                            <FaTimes />
                          )}
                          {barbearia.envio_mensagens ? "Ativo" : "Inativo"}
                        </span>
                      </td>
                      <td>
                        <button
                          type="button"
                          className="ca-button ca-button-secondary"
                          onClick={() => handleEdit(barbearia)}
                        >
                          <FaEdit /> Editar
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <p className="ca-note">
            Em telas menores, deslize a tabela horizontalmente para visualizar
            todas as colunas.
          </p>
        </section>

        <div className="ca-grid">
          <section className="ca-card">
            <div className="ca-card-heading">
              <div className="ca-heading-icon">
                <FaUserTie />
              </div>
              <div>
                <h2>Adicionar funcionário</h2>
                <p>Cadastre um profissional e defina seu horário inicial.</p>
              </div>
            </div>

            <form onSubmit={handleFuncionarioSubmit}>
              <div className="ca-field">
                <label>Barbearia *</label>
                {renderSelectBarbearia(
                  selectedBarbeariaFuncionario,
                  handleBarbeariaFuncionarioChange
                )}
              </div>

              <div className="ca-field" style={{ marginTop: 14 }}>
                <label htmlFor="ca-funcionario-nome">Nome do funcionário *</label>
                <input
                  id="ca-funcionario-nome"
                  className="cronos-input"
                  type="text"
                  name="nome"
                  placeholder="Nome completo"
                  value={funcionarioData.nome}
                  onChange={handleFuncionarioChange}
                  required
                />
              </div>

              <div className="ca-grid" style={{ marginTop: 14 }}>
                <div className="ca-field">
                  <label htmlFor="ca-funcionario-inicio">Início *</label>
                  <input
                    id="ca-funcionario-inicio"
                    className="cronos-input"
                    type="time"
                    name="horario_inicio"
                    value={funcionarioData.horario_inicio}
                    onChange={handleFuncionarioChange}
                    required
                  />
                </div>
                <div className="ca-field">
                  <label htmlFor="ca-funcionario-fim">Fim *</label>
                  <input
                    id="ca-funcionario-fim"
                    className="cronos-input"
                    type="time"
                    name="horario_fim"
                    value={funcionarioData.horario_fim}
                    onChange={handleFuncionarioChange}
                    required
                  />
                </div>
              </div>

              <div className="ca-form-actions">
                <button
                  type="submit"
                  className="ca-button ca-button-primary"
                  disabled={salvandoFuncionario}
                  style={{ width: "100%" }}
                >
                  <FaPlus />
                  {salvandoFuncionario ? "Cadastrando..." : "Adicionar funcionário"}
                </button>
              </div>
            </form>
          </section>

          <section className="ca-card">
            <div className="ca-card-heading">
              <div className="ca-heading-icon">
                <FaClock />
              </div>
              <div>
                <h2>Adicionar horário</h2>
                <p>Defina o expediente de um funcionário por dia da semana.</p>
              </div>
            </div>

            <form onSubmit={handleHorarioSubmit}>
              <div className="ca-field">
                <label>Barbearia *</label>
                {renderSelectBarbearia(
                  selectedBarbeariaHorario,
                  handleBarbeariaHorarioChange
                )}
              </div>

              <div className="ca-field" style={{ marginTop: 14 }}>
                <label>Funcionário *</label>
                {renderSelectFuncionario(
                  horarioData.funcionario_id,
                  handleHorarioChange,
                  funcionariosHorario,
                  !selectedBarbeariaHorario
                )}
              </div>

              <div className="ca-field" style={{ marginTop: 14 }}>
                <label htmlFor="ca-horario-dia">Dia da semana *</label>
                <select
                  id="ca-horario-dia"
                  className="cronos-input"
                  name="dia_da_semana"
                  value={horarioData.dia_da_semana}
                  onChange={handleHorarioChange}
                  required
                >
                  <option value="">Selecione o dia</option>
                  {DIAS_SEMANA.map((dia) => (
                    <option key={dia.value} value={dia.value}>
                      {dia.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="ca-grid" style={{ marginTop: 14 }}>
                <div className="ca-field">
                  <label htmlFor="ca-horario-inicio">Início *</label>
                  <input
                    id="ca-horario-inicio"
                    className="cronos-input"
                    type="time"
                    name="horario_inicio"
                    value={horarioData.horario_inicio}
                    onChange={handleHorarioChange}
                    required
                  />
                </div>
                <div className="ca-field">
                  <label htmlFor="ca-horario-fim">Fim *</label>
                  <input
                    id="ca-horario-fim"
                    className="cronos-input"
                    type="time"
                    name="horario_fim"
                    value={horarioData.horario_fim}
                    onChange={handleHorarioChange}
                    required
                  />
                </div>
              </div>

              <div className="ca-form-actions">
                <button
                  type="submit"
                  className="ca-button ca-button-primary"
                  disabled={salvandoHorario}
                  style={{ width: "100%" }}
                >
                  <FaPlus />
                  {salvandoHorario ? "Salvando..." : "Adicionar horário"}
                </button>
              </div>
            </form>
          </section>
        </div>

        <section className="ca-card">
          <div className="ca-card-heading">
            <div className="ca-heading-icon">
              <FaCoffee />
            </div>
            <div>
              <h2>Adicionar pausa</h2>
              <p>
                Cadastre intervalos para um funcionário em um dia específico.
              </p>
            </div>
          </div>

          <form onSubmit={handlePausaSubmit}>
            <div className="ca-grid-3">
              <div className="ca-field">
                <label>Barbearia *</label>
                {renderSelectBarbearia(
                  selectedBarbeariaPausa,
                  handleBarbeariaPausaChange
                )}
              </div>

              <div className="ca-field">
                <label>Funcionário *</label>
                {renderSelectFuncionario(
                  pausaData.funcionario_id,
                  handlePausaChange,
                  funcionariosPausa,
                  !selectedBarbeariaPausa
                )}
              </div>

              <div className="ca-field">
                <label htmlFor="ca-pausa-dia">Dia da semana *</label>
                <select
                  id="ca-pausa-dia"
                  className="cronos-input"
                  name="dia_da_semana"
                  value={pausaData.dia_da_semana}
                  onChange={handlePausaChange}
                  required
                >
                  <option value="">Selecione o dia</option>
                  {DIAS_SEMANA.map((dia) => (
                    <option key={dia.value} value={dia.value}>
                      {dia.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="ca-field">
                <label htmlFor="ca-pausa-inicio">Início da pausa *</label>
                <input
                  id="ca-pausa-inicio"
                  className="cronos-input"
                  type="time"
                  name="horario_inicio"
                  value={pausaData.horario_inicio}
                  onChange={handlePausaChange}
                  required
                />
              </div>

              <div className="ca-field">
                <label htmlFor="ca-pausa-fim">Fim da pausa *</label>
                <input
                  id="ca-pausa-fim"
                  className="cronos-input"
                  type="time"
                  name="horario_fim"
                  value={pausaData.horario_fim}
                  onChange={handlePausaChange}
                  required
                />
              </div>
            </div>

            <div className="ca-form-footer">
              <button
                type="submit"
                className="ca-button ca-button-primary"
                disabled={salvandoPausa}
              >
                <FaPlus />
                {salvandoPausa ? "Salvando..." : "Adicionar pausa"}
              </button>
            </div>
          </form>
        </section>

        <footer style={{ padding: "6px 0 20px", textAlign: "center", color: "#98a2b3", fontSize: 11 }}>
          Cronos Agenda · Administração da plataforma
        </footer>
      </div>
    </div>
  );
};

export default AdicionarBarbearia;